import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  dialogActions: {
    justifyContent: 'center',
    paddingBottom: theme.spacing(3)
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/dialogs/Confirm/styles.js